import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import mammoth from 'mammoth';
import { applyHighlightsToElement } from './highlight';

export function DocxViewer({ url, height = 'calc(85vh - 44px)', highlightText }: { url: string; height?: string | number; highlightText?: string | null }) {
  const [html, setHtml] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let cancelled = false;
    setError(null);
    setHtml('');

    (async () => {
      try {
        const resp = await fetch(url);
        if (!resp.ok) throw new Error('Failed to fetch DOCX');
        const buf = await resp.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer: buf });
        if (cancelled) return;
        setHtml(result.value || '');
      } catch (e: any) {
        if (cancelled) return;
        setError(e?.message || 'Failed to load DOCX');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [url]);

  useEffect(() => {
    if (!contentRef.current) return;
    if (!html) return;
    applyHighlightsToElement(contentRef.current, highlightText);
  }, [html, highlightText]);

  if (error) return <div style={{ padding: 12, color: 'red' }}>{error}</div>;
  if (!html) return <div style={{ padding: 12 }}>Loading document…</div>;

  return (
    <div style={{ height, overflow: 'auto', padding: 12 }}>
      <div
        ref={contentRef}
        style={{ lineHeight: 1.35, fontSize: 14 }}
        // Mammoth outputs limited HTML; keep this minimal.
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
